'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** ../kettle-ui/~/react-dom/index.js
 ** module id = 468
 ** module chunks = 0
 **/